import * as React from "react";
import { MenuButton, IMenuItem, MenuItemType } from "azure-devops-ui/Menu";

export default class MenuButtonExample extends React.Component {
    private menuItems: IMenuItem[] = [
        { id: "one", text: "Item 1" },
        { id: "two", text: "Item 2" },
        { id: "three", text: "Item 3" },
        { id: "separator", itemType: MenuItemType.Divider },
        { id: "four", text: "Item 4" },
        { id: "five", text: "Item 5" }
    ];

    public render(): JSX.Element {
        return (
            <div style={{ margin: "8px" }}>
                <MenuButton
                    text="Menu button"
                    contextualMenuProps={{
                        menuProps: {
                            id: "test",
                            items: this.menuItems
                        }
                    }}
                />
            </div>
        );
    }
}
